import { itixUserController } from '@x-com/pwitixcomm/tslib/itix.user.ts'
import Alpine from 'alpinejs'

export const initNewsletter = () => {
    Alpine.data('newsletter', () => ({
        init() {
            if (this.$el instanceof HTMLFormElement) {
                const form = this.$el

                form.onsubmit = async (e) => {
                    e.preventDefault()
                    await itixUserController.subscribeNewsletter(new FormData(form))
                    form.innerHTML = '<div class="alert alert--success">' + form.dataset.submitFeedback + '</div>'
                }
            }
        },
    }))
}
